<template>
<a-form :form="form" @submit="onSubmit">
  <a-card>
    <a-form-item label="現在のパスワード" :label-col="{ span: 5 }" :wrapper-col="{ span: 6 }">
      <a-input-search :type="typePwd" @search="onChangeStarPwd" v-decorator="['pwd',{rules: [{ required: true, message: 'Please input your password!' }]}]">
        <a-button slot="enterButton" :icon="eyePwd"></a-button>
      </a-input-search>
    </a-form-item>

    <a-form-item label="新しいパスワード" :label-col="{ span: 5 }" :wrapper-col="{ span: 6 }">
      <a-input-search :type="typeNewPwd" @search="onChangeStarNewPwd" v-decorator="['newpwd',{rules: [
        { required: true, message: 'Please input your new password!' }
        , {validator: validNewPwd}]}]">
        <a-button slot="enterButton" :icon="eyeNewPwd"></a-button>
      </a-input-search>
    </a-form-item>

    <a-form-item label="もう一度入力ください" :label-col="{ span: 5 }" :wrapper-col="{ span: 6 }">
      <a-input-search :type="typeConfirmPwd" @search="onChangeStarConfirmPwd" v-decorator="['confirmpwd',{rules: [
        { required: true, message: 'Please input your new password again!' }
        , {validator: validConfirmPwd}]}]">
        <a-button slot="enterButton" :icon="eyeConfirmPwd"></a-button>
      </a-input-search>
    </a-form-item>
  </a-card>
  <a-form-item>
    <a-button type="primary" html-type="submit">変更</a-button>
  </a-form-item>
</a-form>
</template>

<script>
const p_password_low = /^[0-9a-zA-Z!@#$%^&*?]*(?=.{6,})(?=.*\d)(?=.*[A-Za-z])[0-9a-zA-Z!@#$%^&*?]*$/
const p_password_mid = /^[0-9a-zA-Z!@#$%^&*?]*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z!@#$%^&*?]*$/
const p_password_high = /^[0-9a-zA-Z!@#$%^&*?]*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*?])[0-9a-zA-Z!@#$%^&*?]*$/

export default {
  computed: {
    typePwd: {
      get: function() {
        return this.isPwdStar ? "password" : "string"
      }
    },
    typeNewPwd: {
      get: function() {
        return this.isNewPwdStar ? "password" : "string"
      }
    },
    typeConfirmPwd: {
      get: function() {
        return this.isConfirmPwdStar ? "password" : "string"
      }
    },
    eyePwd: {
      get: function() {
        return this.isPwdStar ? "eye" : "eye-invisible"
      }
    },
    eyeNewPwd: {
      get: function() {
        return this.isNewPwdStar ? "eye" : "eye-invisible"
      }
    },
    eyeConfirmPwd: {
      get: function() {
        return this.isConfirmPwdStar ? "eye" : "eye-invisible"
      }
    }
  },
  created() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      formLayout: 'horizontal',
      isLoading: false,
      pwd: "",
      newpwd: "",
      confirmpwd: "",
      isPwdStar: true,
      isNewPwdStar: true,
      isConfirmPwdStar: true,
      form: this.$form.createForm(this),
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields(['pwd', 'newpwd', 'confirmpwd'], {
        force: true
      }, (err, values) => {
        if (!err) {
          this.$logger.d("ChangePwd", "onSubmit", {
            values: values
          });
          let token = this.$store.getters.token
          this.$api.employee.changePwd({
              token: token,
              pwd_now: values.pwd,
              pwd_new: values.newpwd,
              pwd_confirm: values.confirmpwd
            }).then(data => {
              let resp = data.data;
              this.$logger.d("ChangePwd", "onSubmit", {
                response: resp
              });
              if (resp.error) {
                // this.$notification.error({
                //   message: "エラー:" + resp.error.code,
                //   description: resp.error.description
                // });
                this.$error_handler(this,resp.error)
              } else {
                this.$notification.success({
                  message: "変更しました"
                });
                this.$store.dispatch("logout");
                this.$router.push({
                  path: "/login"
                });
              }
            })
            .catch(err => {
              this.$logger.e("ChangePwd", "onSubmit", {
                error: err
              });
              this.$notification.error({
                message: "エラー",
                description: "サーバ通信エラー"
              });
            });
        }
      });
    },
    onChangeStarPwd() {
      this.isPwdStar = !this.isPwdStar
    },
    onChangeStarNewPwd() {
      this.isNewPwdStar = !this.isNewPwdStar
    },
    onChangeStarConfirmPwd() {
      this.isConfirmPwdStar = !this.isConfirmPwdStar
    },
    validNewPwd(rule, value, callback) {
      const form = this.form;
      if (value && value === form.getFieldValue('pwd')) {
        return callback("Cannot use the same password")
      }
      if (!p_password_low.test(value)) {
        return callback("invalid password")
      }
      callback();
    },
    validConfirmPwd(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('newpwd')) {
        return callback("not confirmed");
      }
      callback();
    },
  },
};
</script>
